import Vue from 'vue';
import JsEncrypt from 'jsencrypt';
Vue.prototype.$encruption = function(obj) {
  let encrypt = new JsEncrypt();
  // 公钥

  encrypt.setPublicKey(
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjpECUM6joglWmXa+d5HFG3nUXKS8LvGugVvubJO8ab7k4Ym8U+T1R7CTOpbdEZgmqV+LNql2N3BKd7BNt8XUagTy5AVJI9x/eOWiWyI9YNsIgQaVDFD0rFBFOBrWk4lNFTb5H3jTR3evZpjIy3Upz/z1K6k0AyJ3PwZxoOA/wThyRaNltzx31SkH2HpBPox/39xYlv8m63UKc9WAIFDpNf4Zcz/7tdx2O8Yr47M8KchdkKXtJSDhWgJBkTb/dtyRrugDmC/HQ0A95g5cX95R1OhYvJYxa7CrsDlcLCYd5ofIARzUB49GvdZYEfPF4GmUOM+ig8lX9tRzEiDIH0BGiQIDAQAB'
  );
  return encrypt.encrypt(obj);
};
// Vue.prototype.$rsaPrivateData = function(obj) {
//   let jsencrypt = new JSEncrypt();
//   jsencrypt.setPrivateKey(
//     'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjpECUM6joglWmXa+d5HFG3nUXKS8LvGugVvubJO8ab7k4Ym8U+T1R7CTOpbdEZgmqV+LNql2N3BKd7BNt8XUagTy5AVJI9x/eOWiWyI9YNsIgQaVDFD0rFBFOBrWk4lNFTb5H3jTR3evZpjIy3Upz/z1K6k0AyJ3PwZxoOA/wThyRaNltzx31SkH2HpBPox/39xYlv8m63UKc9WAIFDpNf4Zcz/7tdx2O8Yr47M8KchdkKXtJSDhWgJBkTb/dtyRrugDmC/HQ0A95g5cX95R1OhYvJYxa7CrsDlcLCYd5ofIARzUB49GvdZYEfPF4GmUOM+ig8lX9tRzEiDIH0BGiQIDAQAB'
//   );
//   // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
//   return jsencrypt.encrypt(obj);
// };
